module.exports = __webpack_public_path__ + "img/plant-bottom.f4efcb16.svg";